import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import ListGroup from "react-bootstrap/ListGroup";
import Tab from "react-bootstrap/Tab";

function SwayamPrabha() {

    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Swayam Prabha" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <Row>
                        <div className="c-heading">  
                            <h1>SwayamPrabha - MHRD initiative</h1>
                        </div> 
                        <Col md={2} className="c-left ">
                            <Tab.Container id="list-group-tabs-example" defaultActiveKey="#link1">
                                <ListGroup>
                                    <ListGroup.Item as={Link} action to="https://swayamprabha.gov.in/index.php/higheredu" target='_blank' className={`p-3 `}>
                                        <i className="fas fa-chevron-circle-right me-3"></i>
                                        Channel 37
                                    </ListGroup.Item>
                                </ListGroup>
                                <ListGroup>
                                    <ListGroup.Item as={Link} action to="https://swayamprabha.gov.in/index.php/higheredu" target='_blank' className={`p-3 `}>
                                        <i className="fas fa-chevron-circle-right me-3"></i>
                                        Channel 38
                                    </ListGroup.Item>
                                </ListGroup>
                            </Tab.Container>
                        </Col>
                        <Col md={10} className="c-left ">
                            <div className='my-3'>
                                For more details about SWAYAM PRABHA, please visit 
                                <Link className='c-link' to="https://swayamprabha.gov.in" target="_blank">Swayam Prabha | Educational DTH channels | India</Link>
                            </div>
                            <div className="">
                                <img src="https://files.iittp.ac.in/images/demo/iit/Other/Swayamprabha_Pic.png" alt="Swayamprabha" />
                            </div>

                        </Col>
                    </Row>

                </div>
            </section>
        </>
    )
}

export default SwayamPrabha;